module.exports = __webpack_public_path__ + "files/remi.c788cd0d168e79b86dd9065bd6aba1b8.pdf";